/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback, useRef } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, Typography, Box, useTheme, Grid, Divider, Avatar, Chip, Card, CardContent, IconButton, Zoom, TextField, InputAdornment, Alert, Snackbar, DialogTitle,
  DialogContentText, List, ListItem, CircularProgress, Paper, ListItemText, ListItemAvatar, ListItemButton, Tooltip, Stack, LinearProgress, alpha, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import {
  Payment as PaymentIcon, Receipt as ReceiptIcon, Add as AddIcon, ReceiptLong as ReceiptLongIcon, CheckCircle as CheckCircleIcon, DeleteOutline as DeleteIcon,
  Money as MoneyIcon, CreditCard as CreditCardIcon, Pix as PixIcon, Receipt as ReceiptOutlinedIcon, Keyboard as KeyboardIcon, Percent as PercentIcon,
  RequestQuoteOutlined as RequestQuoteIcon, PersonAddAlt1 as PersonAddIcon, Person as PersonIcon, AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import { jwtDecode } from 'jwt-decode';
import * as yup from 'yup';
import { AutoCompleteParceiro, BasicSelect, useVForm, VTextFieldNumber } from '../../shared/forms';
import { AutoCompleteContaBancariaSimple } from '../../shared/forms/AutoCompleteContaBancariaSimples';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { VendasService } from '../../shared/services/api/Venda/venda';
import { impressaoVendaOffline } from '../../shared/offline/vendaOffline';
import { Environment } from '../../shared/environment';
import { Form } from '@unform/web';
import { DialogVisualizarVenda } from './VisualizarPDF';
import { Dialogsendnfce } from './DialogEmitirnfce';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { VFieldMoney2Faturamento } from './VFieldMoney2Faturamento';
import { VFieldMoney2ValorItem } from './VFieldMoney2ValorItem';
import { EstoqueOperacoesService } from '../../shared/services/api/Venda/EstoqueOperacoesService';
import PDFVenda01 from './impressaopadrao';
import PDFVendaTermica from './impressaotermica';
import { DialogDescontoAcrescimo } from './DialogDescontoAcrescimo';
import { DialogNovoParceiro } from './DialogNovoParceiro';
import { DialogSelecionarParceiro } from './DialogSelecionarParceiro';
import { PDVThemeColors } from './PDVThemes';
import { SpinningLogo } from '../../shared/components';
import { MQ_PHONE } from './pdvScale';
import { DialogAutorizacaoGerente } from './DialogAutorizacaoGerente';
import { SessaoCaixaService, IDadosEdicaoVendaPdv } from '../../shared/services/api/Venda/SessaoCaixaService';

interface IFormData {
  idparceiro: string;
  idmov: string;
  idplanoconta: string;
  iduser: string;
  numero: string;
  idoperacao: string;
  emissao: string;
  vprod: number;
  desconto: number;
  total: number;
  acrescimo: number;
  tipovenda: string;
  obs?: string;
  formasPagamento?: IFormaPagamentoEnvio[];
  pagamento?: string;
  qtdparcelas?: number;
}

interface IFormaPagamentoEnvio {
  idoperacao: string;
  valor: number;
  nome: string;
  // Rótulo pro caixa distinguir Dinheiro/PIX/Cartão/Outros na tela de
  // Faturamento — igual a `nome` no PDV, mas mandado à parte porque é o
  // campo que o backend realmente usa pra categorizar o lançamento.
  categoria: string;
  // Conta escolhida manualmente pro PIX Estático (a conta bancária de
  // destino do QR Code fixo) — tem prioridade no roteamento do backend
  // sobre a resolução automática por categoria (Cartão Crédito/PIX
  // Dinâmico caem sozinhos na recebível fixa; Dinheiro cai na sessão).
  idcontadestino?: string;
}

interface IitensVendaDialog {
  iditens: string;
  idprodutos: string;
  idref?: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  localizado?: string;
  original?: boolean;
  ean?: string;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro?: string;
  referencia?: string;
  marca?: string;
  status?: number;
  descricao: string;
}

interface IParcelasFaturamento {
  idrec: string;
  idplanoconta: string;
  idparceiro: string;
  emissao: string;
  vencimento: string;
  tipo: number;
  parcela: string;
  vreceber: number;
  desconto: number;
  acrescimo: number;
  vrecebido: number;
  vparcela: number;
  pagamento: string;
  juros: number;
  historico: string;
  qtdparcelas: number;
  venda: number;
}

interface IFormaPagamentoSelecionada {
  id: string;
  idoperacao: string;
  nome: string;
  descricao: string;
  valor: number;
  icon: React.ReactNode;
  // Só preenchido pra PIX Estático (ver precisaContaDestino).
  idcontadestino?: string;
  contaDestinoLabel?: string;
}

interface IOperacaoPagamento {
  id: string;
  nome: string;
  descricao: string;
  icon: React.ReactNode;
  tipo: 'vista' | 'prazo' | 'orcamento';
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  status: boolean;
  dados?: IFormData;
  dadosItens?: IitensVendaDialog[];
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
  colors: PDVThemeColors;
  // Conta bancária padrão do PIX Estático (ver /configuracaopdv) — quando
  // configurada, a venda não pergunta mais a conta (ver precisaContaDestino
  // e temContaPadraoPix abaixo), ela é usada direto no roteamento do PIX
  // pra conciliação.
  contaPadraoPix?: { id: string; label: string };
  // Opção "Preview" de /configuracaopdv (ver Pdv.tsx). true (padrão):
  // depois de finalizar a venda, abre a tela de visualizar/reimprimir
  // (DialogVisualizarVenda), com "Emitir nota" como botão dentro dela.
  // false: pula essa tela e já abre direto a emissão da nota fiscal (ver
  // handleImpressao abaixo).
  previewImpressao?: boolean;
  // Mensagens de sucesso vão pro header do PDV (ver mostrarMensagem em
  // Pdv.tsx) em vez do Snackbar flutuante — erro/aviso continuam aqui.
  onMensagemSucesso?: (texto: string) => void;
  // Número da venda sendo editada (só pra exibir) — vem junto quando `id`
  // (ver idProp) não é 'novo', ou seja, quando o carrinho representa uma
  // venda EXISTENTE sendo editada (ver "Editar venda" em
  // DialogResumoVendasPDV.tsx), não uma venda nova.
  numeroVendaEmEdicao?: string;
}

interface JwtPayload {
  idempresa: string;
  iduser: string;
  tipoimp: number;
  refs: boolean;
  img: string;
  decimais: number;
}

dayjs.extend(utc);
dayjs.extend(timezone);

// Cor fixa para "desconto" (não usa vermelho, que já é reservado para erros)
const DESCONTO_COLOR = '#0D9488';
// Cor fixa para "Total a pagar" (não acompanha o tema do PDV)
const TOTAL_PAGAR_COLOR = '#2563EB';

const MAX_PARCELAS = 200;
// Roteamento de conta por forma de pagamento (mesmo modelo já usado em
// Faturamento/ContasReceber, ver backendsiac CreatePdv.ts): Dinheiro cai na
// conta da sessão (idconta enviado no header, sem mudança aqui); Cartão
// Crédito e PIX Dinâmico caem sozinhos na recebível fixa correspondente
// (resolverContaRecebivelPorCategoria, por texto da categoria); PIX
// Estático pede a conta bancária de destino na hora (idcontadestino), por
// ser o QR Code fixo de uma conta específica. Cartão e PIX aqui são só um
// item cada na lista — Crédito/Débito e Estático/Dinâmico são escolhidos
// DEPOIS do valor, por um toggle (ver precisaTipoCartao/precisaTipoPix),
// não são itens separados na lista.
const OPERACOES: IOperacaoPagamento[] = [
  { id: Environment.IDVENDAAVISTA, nome: 'Dinheiro', descricao: '', icon: <MoneyIcon />, tipo: 'vista' },
  { id: Environment.IDPIX, nome: 'PIX', descricao: '', icon: <PixIcon />, tipo: 'vista' },
  { id: Environment.IDCARTAO, nome: 'Cartão', descricao: '', icon: <CreditCardIcon />, tipo: 'vista' },
  { id: Environment.IDORCAMENTO, nome: 'Orçamento', descricao: '', icon: <RequestQuoteIcon />, tipo: 'orcamento' },
  { id: Environment.IDVENDAPRAZO, nome: 'Crediário', descricao: '', icon: <ReceiptOutlinedIcon />, tipo: 'prazo' },
];
const pagamentoSchema = yup.object().shape({
  idmov: yup.string().required('ID do movimento é obrigatório'),
  idparceiro: yup.string().required('Parceiro é obrigatório'),
  idplanoconta: yup.string().required('Plano de contas é obrigatório'),
  idoperacao: yup.string().required('Operação é obrigatória'),
  numero: yup.string().optional().default(''),
  emissao: yup.string().required('O campo é obrigatório').test('valid-date', 'Selecione uma data válida', function (value) {
    if (!value) return false;
    const currentDate = dayjs().tz('America/Sao_Paulo').startOf('day');
    const dateValue = dayjs(value).tz('America/Sao_Paulo').startOf('day');
    return dateValue.isValid() && !dateValue.isAfter(currentDate);
  }),
  vprod: yup.number().required().moreThan(0, 'Valor dos produtos deve ser maior que zero'),
  desconto: yup.number().required().min(0, 'Desconto não pode ser negativo'),
  total: yup.number().required().moreThan(0, 'Total deve ser maior que zero'),
  acrescimo: yup.number().required().min(0, 'Acréscimo não pode ser negativo'),
  obs: yup.string().optional().max(200),
});

// ─── Componente de tecla de atalho ─────────────────────────────────────────
const KbdChip: React.FC<{ label: string }> = ({ label }) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 0.6,
        py: 0.1,
        border: `0.5px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        fontSize: '10px',
        fontFamily: 'monospace',
        color: theme.palette.text.secondary,
        bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
        lineHeight: 1.6,
        mx: 0.3,
      }}
    >
      {label}
    </Box>
  );
};

// Arredondamento monetário (2 casas por padrão) usado em todos os cálculos de
// item/total da venda abaixo — Number.toFixed(2) sozinho não bastava: valores
// como 10.20 viravam number 10.2 (JS não guarda zero à direita) e, sem
// arredondar a ORIGEM do cálculo (subtotal, desconto, acréscimo, total), ruído
// de ponto flutuante (ex.: 45.900000000000006, de somas de qtds*preco) passava
// direto pro payload enviado ao backend. Passar um `decimals` explícito
// diferente de 2 é só pra proporção de rateio de desconto/acréscimo entre
// itens (percentualItem/proporcao abaixo), que precisa de mais casas pra não
// distorcer o rateio — o valor final de cada item continua sendo arredondado
// a 2 casas antes de ir pro objeto enviado.
const round = (value: number, decimals = 2): number => {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
};

export const DialogVendapdv: React.FC<ConfirmationDialogRawProps> = (props) => {
  const { formRef } = useVForm();
  const { onClose, open, id: idProp, dadosItens, colors, contaPadraoPix, previewImpressao = true, numeroVendaEmEdicao } = props;
  // idProp !== 'novo': o carrinho representa uma venda EXISTENTE sendo
  // editada (ver "Editar venda" em DialogResumoVendasPDV.tsx/Pdv.tsx) — ao
  // finalizar, faz UPDATE nessa venda (idProp = idmov dela) em vez de criar
  // outra. Pedido explícito: "quando puxar a venda... fazer update... e não
  // criar outra venda".
  const estaEditandoVenda = idProp !== 'novo';
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessageVenda, setLoadingMessageVenda] = useState('Gravando venda...');
  // Percentual mostrado no Backdrop de loading (0-100) — a API não manda
  // progresso de verdade (é uma chamada só, não um upload em pedaços), então
  // simula um avanço suave (mais rápido no início, indo devagar perto de
  // 90%) enquanto isLoading estiver true, ver useEffect abaixo. Só chega a
  // 100% de propósito (via concluirProgressoComSucesso) quando a operação
  // realmente termina — nunca sozinho.
  const [progressoVenda, setProgressoVenda] = useState(0);
  const progressoIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (isLoading) {
      setProgressoVenda(0);
      progressoIntervalRef.current = setInterval(() => {
        setProgressoVenda((atual) => {
          if (atual >= 90) return atual;
          const incremento = (90 - atual) * 0.12 + 0.6;
          return Math.min(90, atual + incremento);
        });
      }, 150);
    }
    return () => {
      if (progressoIntervalRef.current) {
        clearInterval(progressoIntervalRef.current);
        progressoIntervalRef.current = null;
      }
    };
  }, [isLoading]);

  // Chamar nos caminhos de ERRO (venda não foi salva) — some na hora, sem
  // fingir que chegou a 100%.
  const pararProgressoComErro = () => {
    setIsLoading(false);
    setProgressoVenda(0);
  };

  // Chamar quando a operação (gravar venda + gerar PDF/preparar NFC-e)
  // terminou com sucesso — sobe pra 100% e segura por um instante antes de
  // fechar o Backdrop, senão o operador nunca chegava a VER "100%" (o
  // avanço simulado para em 90%, e sem essa pausa o Backdrop já tinha
  // sumido no mesmo instante que o número chegasse lá).
  const concluirProgressoComSucesso = (aoFechar?: () => void) => {
    setProgressoVenda(100);
    setTimeout(() => {
      setIsLoading(false);
      aoFechar?.();
    }, 350);
  };
  const [iduser, setiduser] = useState<string>('');
  const [tpag, setTpag] = useState<number>();
  const theme = useTheme();
  const [selectedTotal, setSelectedTotal] = useState(0);
  const [idParceiroSelecionado, setIdParceiroSelecionado] = useState<string>(Environment.URL_IDPARCEIRO);
  const idplanodecontas = Environment.URL_IDPLANODECONTAS;
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const valorRef = useRef<HTMLInputElement | null>(null);
  const parceiroRef = useRef<HTMLInputElement | null>(null);
  const [faturamento, setFaturamento] = useState<boolean>();
  const [openDialogNfce, setOpenDialogNfce] = useState(false);
  const [openDialogPagamento, setOpenDialogPagamento] = useState(false);
  const [incluirCpf, setIncluirCpf] = useState<boolean | undefined>(undefined);
  const [openCpfDialog, setOpenCpfDialog] = useState(false);
  const [openDescontoDialog, setOpenDescontoDialog] = useState(false);
  const [openNovoParceiroDialog, setOpenNovoParceiroDialog] = useState(false);
  const [openSelecionarParceiroDialog, setOpenSelecionarParceiroDialog] = useState(false);
  const [nomeParceiroSelecionado, setNomeParceiroSelecionado] = useState('');
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [listaParcelas, setListaParcelas] = useState<IParcelasFaturamento[]>([]);
  const [qtdParcelas, setQtdParcelas] = useState(1);
  const [tipoPagamentoFat, setTipoPagamentoFat] = useState('carteira');
  const [gerandoParcelas, setGerandoParcelas] = useState(false);
  const [desconto, setDesconto] = useState<number>(0);
  const [acrescimo, setAcrescimo] = useState<number>(0);
  const [tipoDesconto, setTipoDesconto] = useState<'valor' | 'percentual'>('valor');
  const [tipoAcrescimo, setTipoAcrescimo] = useState<'valor' | 'percentual'>('valor');
  const [formasPagamentoSelecionadas, setFormasPagamentoSelecionadas] = useState<IFormaPagamentoSelecionada[]>([]);
  const [valorPagamentoTemp, setValorPagamentoTemp] = useState<number>(0);
  const [operacaoSelecionadaIndex, setOperacaoSelecionadaIndex] = useState<number>(0);
  // Conta bancária de destino do PIX Estático — só pedida pra essa forma
  // (ver precisaContaDestino), zerada sempre que troca de forma de
  // pagamento (mesmo padrão do limparDetalhes em SeletorFormasPagamento.tsx,
  // usado em Faturamento/ContasReceber).
  const [idContaDestinoTemp, setIdContaDestinoTemp] = useState('');
  const [contaDestinoLabelTemp, setContaDestinoLabelTemp] = useState('');
  // Cartão/PIX pedem um segundo passo depois do valor: Crédito ou Débito
  // (Cartão), Estático ou Dinâmico (PIX) — ver precisaTipoCartao/
  // precisaTipoPix e o fluxo de Enter em handleValorKeyDown.
  const [tipoCartao, setTipoCartao] = useState<'credito' | 'debito'>('credito');
  const [tipoPix, setTipoPix] = useState<'estatico' | 'dinamico'>('estatico');
  const tipoCartaoToggleRef = useRef<HTMLButtonElement>(null);
  const tipoPixToggleRef = useRef<HTMLButtonElement>(null);
  const contaDestinoInputRef = useRef<HTMLInputElement>(null);
  const selectRef = useRef<HTMLDivElement>(null);
  const listItemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [openNotaFiscalDialog, setOpenNotaFiscalDialog] = useState(false);
  const [ultimoIdmovCriado, setUltimoIdmovCriado] = useState<string>('');
  const [idVendaImpressao, setIdVendaImpressao] = useState('');
  const [notaEmitidaComSucesso, setNotaEmitidaComSucesso] = useState(false);
  const [vendaConcluidaComSucesso, setVendaConcluidaComSucesso] = useState(false);
  const [ultimaVendaOrcamento, setUltimaVendaOrcamento] = useState(false);
  // Categoria da forma de pagamento da venda que acabou de ser concluída
  // ('Dinheiro', 'Cartão Crédito', 'Cartão Débito', 'PIX Estático', 'PIX
  // Dinâmico'...) — capturada ANTES do resetForm() (que zera
  // formasPagamentoSelecionadas) pra chegar em Dialogsendnfce e pré-
  // selecionar lá a mesma forma usada na venda.
  const [ultimaFormaPagamentoVenda, setUltimaFormaPagamentoVenda] = useState('');
  // Resumo de como a venda que acabou de ser concluída foi paga — capturado
  // no mesmo instante que ultimaFormaPagamentoVenda (ANTES do resetForm()),
  // pra tela de finalizar venda mostrar isso em vez de "falta pagar" (que
  // não faz mais sentido depois que os dados de pagamento já foram
  // zerados) enquanto o operador não sai de vez (ESC/Fechar).
  const [ultimoResumoPagamento, setUltimoResumoPagamento] = useState<{
    formas: { nome: string; valor: number }[];
    totalPago: number;
    totalFinal: number;
    nomeParceiro: string;
    aPrazo: boolean;
    qtdParcelas: number;
  } | null>(null);
  const tpagAnterior = useRef<number | undefined>();
  // Trava contra duplo-clique/duplo-F12 em finalizarVenda — `isLoading` (state)
  // não chega a tempo: entre o clique e o React desabilitar o botão via
  // re-render existe uma janela síncrona onde um segundo clique/F12 ainda
  // encontra o botão habilitado. Ref é síncrona (não depende de re-render),
  // então bloqueia mesmo nessa janela. Só vira true um pouco antes da
  // chamada de verdade pro backend (ver finalizarVenda) — não trava um
  // segundo clique só porque a 1ª tentativa falhou numa validação (forma de
  // pagamento faltando etc.), que nem chega a setar isso.
  const enviandoVendaRef = useRef(false);
  // Autorização (usuário/senha de quem aprova) pra confirmar a edição —
  // mesmo padrão de DialogResumoVendasPDV (cancelar/devolução): o backend
  // confere credencial+permissão numa chamada só (ver
  // AutorizarUsuarioPdv.ts/EditarVendaPdv.ts). `pendingEdicao` guarda os
  // dados já calculados, prontos pra enviar assim que autorizado.
  const [openAutorizacaoEdicao, setOpenAutorizacaoEdicao] = useState(false);
  const [pendingEdicao, setPendingEdicao] = useState<IDadosEdicaoVendaPdv | null>(null);
  const totalItens = round(dadosItens?.reduce((acc, item) => acc + (item.qtds * item.preco), 0) || 0);
  const quantidadeItens = dadosItens?.length || 0;

  const formatarMoeda = (valor: number | undefined | null): string => {
    if (valor === undefined || valor === null || isNaN(valor)) return 'R$ 0,00';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const fontSizeTotalPagar = (valorFormatado: string): string => {
    const tamanho = valorFormatado.length;
    if (tamanho <= 8) return '2rem';
    if (tamanho <= 11) return '1.6rem';
    if (tamanho <= 14) return '1.3rem';
    return '1.1rem';
  };

  const calcularValorComDesconto = (): number => {
    if (tipoDesconto === 'percentual') return round((totalItens * desconto) / 100);
    return round(desconto);
  };

  const calcularValorComAcrescimo = (): number => {
    if (tipoAcrescimo === 'percentual') return round((totalItens * acrescimo) / 100);
    return round(acrescimo);
  };

  const valorDesconto = calcularValorComDesconto();
  const valorAcrescimo = calcularValorComAcrescimo();
  const totalFinal = round(totalItens + valorAcrescimo - valorDesconto);
  const totalPago = round(formasPagamentoSelecionadas.reduce((acc, i) => acc + i.valor, 0));
  const totalPagoSuficiente = totalPago >= totalFinal - 0.001;
  const faltaPagar = round(Math.max(0, totalFinal - totalPago));
  const troco = round(Math.max(0, totalPago - totalFinal));
  const percentualPago = totalFinal > 0 ? Math.min(100, (totalPago / totalFinal) * 100) : 0;
  const operacaoSelecionada = OPERACOES[operacaoSelecionadaIndex];
  const isOrcamento = operacaoSelecionada?.tipo === 'orcamento';
  // Cartão pede Crédito/Débito, PIX pede Estático/Dinâmico — os dois só
  // depois do valor (ver handleValorKeyDown). Só PIX Estático pede a conta
  // bancária de destino além disso — Dinheiro cai na sessão, Cartão
  // Crédito/Débito e PIX Dinâmico caem sozinhos na recebível fixa (ver
  // comentário do OPERACOES acima).
  const precisaTipoCartao = operacaoSelecionada?.nome === 'Cartão';
  const precisaTipoPix = operacaoSelecionada?.nome === 'PIX';
  // Conta configurada em Configurações do PDV (F10) — travada, o operador
  // não escolhe mais a conta na hora da venda (ver AutoCompleteContaBancariaSimple
  // mais abaixo, só renderizado quando isso for false).
  const temContaPadraoPix = !!contaPadraoPix?.id;
  const precisaContaDestino = precisaTipoPix && tipoPix === 'estatico' && !temContaPadraoPix;

  // ─── Cores dinâmicas do tema ────────────────────────────────────────────────
  const isDark = theme.palette.mode === 'dark';
  const borderColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)';
  const bgSubtle = isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)';

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (selectRef.current) {
          selectRef.current.focus();
          setOperacaoSelecionadaIndex(0);
        }
      }, 100);
    }
  }, [open]);

  const resetForm = () => {
    formRef.current?.reset();
    setDesconto(0);
    setAcrescimo(0);
    setListaParcelas([]);
    setQtdParcelas(1);
    setTipoPagamentoFat('carteira');
    setTpag(undefined);
    setFormasPagamentoSelecionadas([]);
    setValorPagamentoTemp(0);
    setOperacaoSelecionadaIndex(0);
    setIdParceiroSelecionado(Environment.URL_IDPARCEIRO);
    setNomeParceiroSelecionado('');
    setTimeout(() => {
      formRef.current?.setFieldValue('pagamento', 'carteira');
      formRef.current?.setFieldValue('qtdparcelas', 1);
      formRef.current?.setFieldValue('idparceiro', Environment.URL_IDPARCEIRO);
      if (selectRef.current) selectRef.current.focus();
    }, 0);
  };

  const handleImpressao = async (id: string, comoOrcamento: boolean = false) => {
    // Preview desligado (ver /configuracaopdv, Pdv.tsx) — pula a tela de
    // visualizar/reimprimir (DialogVisualizarVenda) e já abre direto a
    // emissão da nota fiscal, mesmo passo que o botão "Emitir nota" dentro
    // daquela tela faria (ver onEmitirNota, mais abaixo no JSX). Não gera
    // o PDF de cupom por não ser mais necessário aqui — continua disponível
    // depois, por reimpressão.
    // NÃO reseta o formulário nem fecha esta tela aqui — a venda já foi
    // criada, mas a tela de finalizar venda continua aberta por baixo da
    // nota (ver handleCloseNfceDialog logo abaixo e o botão "Emitir NFC-e"
    // no rodapé), pro operador poder reabrir a emissão se fechar sem
    // emitir. Só sai de vez e reseta pra uma venda nova no Cancelar/ESC/X
    // (ver handleClose), a pedido.
    // Venda salva offline (ainda na fila, ver shared/offline) não tem como
    // emitir nota agora (precisa do servidor) — sempre cai no cupom local.
    const vendaOffline = !!(await impressaoVendaOffline(id));
    if (!previewImpressao && !vendaOffline) {
      setNotaEmitidaComSucesso(false);
      setUltimoIdmovCriado(id);
      setOpenDialogNfce(true);
      return;
    }

    setIsGeneratingPdf(true);
    try {
      setOpenmsg(false);
      const result = await VendasService.Impressao(id);
      if (result instanceof Error) {
        setTms('error'); setMsg(result.message); setOpenmsg(true);
      } else {
        const pdfBlob: Blob = await PDFVenda01(result, comoOrcamento);
        if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
        const blobUrl = URL.createObjectURL(pdfBlob);
        setPdfBlobUrl(blobUrl);
        setNotaEmitidaComSucesso(false);
        setOpenPdfViewer(true);
        setTimeout(() => {
          resetForm();
          props.onDados?.({ idparceiro: '', idmov: '', idplanoconta: '', iduser: '', numero: '', idoperacao: '', emissao: '', vprod: 0, desconto: 0, total: 0, acrescimo: 0, tipovenda: '', obs: '' });
        }, 200);
      }
    } catch {
      setTms('error'); setMsg('Erro ao gerar o PDF'); setOpenmsg(true);
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  useEffect(() => {
    if (open) {
      const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
      let iduserr = '';
      if (accessToken) {
        const decoded = jwtDecode<JwtPayload>(accessToken);
        iduserr = decoded.iduser || '';
        setiduser(iduserr);
      }
      setVendaConcluidaComSucesso(false);
      setNotaEmitidaComSucesso(false);
      setUltimaVendaOrcamento(false);
      setUltimaFormaPagamentoVenda('');
      setUltimoResumoPagamento(null);
      // Referências da venda anterior (preview desligado, ver
      // podeReabrirNfce) — sem isso, abrir "Finalizar venda" pra uma venda
      // nova ainda carregava o id/diálogo da venda de antes por baixo.
      setIdVendaImpressao('');
      setUltimoIdmovCriado('');
      setOpenDialogNfce(false);
      setOpenPdfViewer(false);
      // Nova venda começando do zero — nunca deve herdar a trava de envio
      // da venda anterior.
      enviandoVendaRef.current = false;
      resetForm();
      setTimeout(() => {
        formRef.current?.setData({ idparceiro: idParceiroSelecionado || '', idoperacao: '', idplanoconta: idplanodecontas || '', iduser: iduserr, numero: '', emissao: '', vprod: 0, desconto: 0, total: 0, acrescimo: 0, obs: '', pagamento: 'carteira', qtdparcelas: 1 });
        setValorPagamentoTemp(0);
      }, 50);
    }
  }, [open]);

  const handleCloseNfceDialog = (status?: string) => {
    setOpenDialogNfce(false);
    if (status === 'success') {
      // Nota emitida com sucesso — não faz mais sentido voltar pra "Venda
      // concluída"/Emitir NFC-e (a nota já foi emitida, não tem o que
      // reabrir), então fecha a venda inteira igual ao Cancelar/ESC/X (ver
      // handleClose) e já cai numa venda nova.
      setNotaEmitidaComSucesso(true);
      resetForm();
      onClose?.('success');
      return;
    }
    // Sem emitir (fechou no X/Sair/ESC, ou desistiu depois de um erro) com a
    // venda já finalizada — também vai direto pra uma venda nova, em vez de
    // voltar pra tela de "Venda concluída" (a pedido). A nota pode ser
    // emitida depois em "Notas Fiscais" → "Sem nota" (rodapé do PDV).
    if (vendaConcluidaComSucesso) {
      resetForm();
      onClose?.('success');
    }
  };

  const handleCloseVisualizarVenda = () => {
    setOpenPdfViewer(false);
    onClose?.(vendaConcluidaComSucesso ? 'success' : undefined);
  };

  const handleKeyDownOpcoes = (event: React.KeyboardEvent) => {
    // atalhos numéricos 1–4
    const num = parseInt(event.key);
    if (num >= 1 && num <= OPERACOES.length) { event.preventDefault(); selecionarOperacao(num - 1); }
  };

  useEffect(() => {
    listItemRefs.current[operacaoSelecionadaIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [operacaoSelecionadaIndex]);

  useEffect(() => {
    if (tpagAnterior.current === undefined) { tpagAnterior.current = tpag; return; }
    if (tpag === 2 && tpagAnterior.current !== 2) { setFormasPagamentoSelecionadas([]); setValorPagamentoTemp(0); }
    if (tpag !== 2 && tpagAnterior.current === 2) { setListaParcelas([]); setQtdParcelas(1); setTipoPagamentoFat('carteira'); formRef.current?.setFieldValue('qtdparcelas', 1); formRef.current?.setFieldValue('pagamento', 'carteira'); }
    tpagAnterior.current = tpag;
  }, [tpag]);

  const handleValorPagamentoChange = useCallback((id: string, valor: string) => {
    let novoValor = Number(valor) || 0;
    if (isNaN(novoValor) || novoValor < 0) novoValor = 0;
    setValorPagamentoTemp(novoValor);
  }, []);

  const selecionarOperacao = async (index: number, focarValor: boolean = true) => {
    setOperacaoSelecionadaIndex(index);
    setIdContaDestinoTemp('');
    setContaDestinoLabelTemp('');
    setTipoCartao('credito');
    setTipoPix('estatico');
    // focarValor=false é só navegação (setas, ver o listener global de
    // teclado) passando o destaque por cima das opções — não é uma escolha
    // confirmada ainda. Sem esse corte, só passar por "Orçamento"/
    // "Crediário" a caminho de outra opção (ex.: de Dinheiro pra Cartão) já
    // disparava a busca abaixo e apagava as formas de pagamento parciais já
    // adicionadas (ver os dois `setFormasPagamentoSelecionadas([])` abaixo e
    // o useEffect de [tpag], que reage a essa mesma mudança). Confirmar de
    // verdade é clique, atalho numérico (handleKeyDownOpcoes) ou Enter — os
    // três já chamam esta função com focarValor true (o default).
    if (!focarValor) return;
    const operacao = OPERACOES[index];
    if (!operacao) return;
    const result = await EstoqueOperacoesService.getById(operacao.id);
    if (result instanceof Error) { setTms('error'); setMsg(result.message); setOpenmsg(true); return; }
    setFaturamento(result.faturamento);
    setTpag(result.tpag);
    if (operacao.tipo === 'orcamento') {
      setFormasPagamentoSelecionadas([]);
      setValorPagamentoTemp(0);
      return;
    }
    const valorRestante = Math.max(0, totalFinal - totalPago);
    setValorPagamentoTemp(valorRestante);
    if (result.tpag === 2) {
      setFormasPagamentoSelecionadas([]); setValorPagamentoTemp(0); setSelectedTotal(valorRestante); setTpag(2);
      setTimeout(() => { formRef.current?.setFieldValue('qtdparcelas', 1); formRef.current?.setFieldValue('pagamento', 'boleto'); }, 0);
      if (focarValor) { setTimeout(() => { parceiroRef.current?.focus(); }, 100); }
      return;
    }
    if (tpag === 2 && result.tpag !== 2) { setListaParcelas([]); setQtdParcelas(1); setTipoPagamentoFat('carteira'); }
    if (focarValor) { setTimeout(() => { valorRef.current?.focus(); valorRef.current?.select(); }, 100); }
  };

  const adicionarFormaPagamento = () => {
    if (faltaPagar <= 0.01) { setTms('warning'); setMsg('A venda já foi totalmente paga!'); setOpenmsg(true); return; }
    if (!operacaoSelecionada) { setTms('warning'); setMsg('Selecione uma forma de pagamento!'); setOpenmsg(true); return; }
    if (valorPagamentoTemp <= 0) { setTms('warning'); setMsg('Informe um valor válido!'); setOpenmsg(true); return; }
    if (operacaoSelecionada.tipo === 'prazo') { setTpag(2); setSelectedTotal(totalFinal); return; }
    if (operacaoSelecionada.tipo === 'orcamento') { finalizarVenda(); return; }
    if (precisaContaDestino && !idContaDestinoTemp) { setTms('warning'); setMsg('Selecione a conta bancária de destino do PIX Estático!'); setOpenmsg(true); return; }
    // Nome/categoria enviados refletem o sub-tipo escolhido no toggle
    // (Crédito/Débito, Estático/Dinâmico) — é esse texto que o backend usa
    // pra rotear a conta (resolverContaRecebivelPorCategoria).
    const categoriaEfetiva = precisaTipoCartao
      ? (tipoCartao === 'credito' ? 'Cartão Crédito' : 'Cartão Débito')
      : precisaTipoPix
        ? (tipoPix === 'estatico' ? 'PIX Estático' : 'PIX Dinâmico')
        : operacaoSelecionada.nome;
    // PIX Estático: conta configurada em Configurações do PDV tem prioridade
    // sobre a escolhida manualmente (só existe uma das duas por vez, ver
    // precisaContaDestino — o campo manual nem aparece quando há padrão).
    const pixEstatico = precisaTipoPix && tipoPix === 'estatico';
    const idContaDestinoEfetiva = pixEstatico ? (contaPadraoPix?.id || idContaDestinoTemp) : undefined;
    const contaDestinoLabelEfetiva = pixEstatico ? (contaPadraoPix?.label || contaDestinoLabelTemp) : undefined;
    const novaForma: IFormaPagamentoSelecionada = {
      id: uuidv4(),
      idoperacao: operacaoSelecionada.id,
      nome: categoriaEfetiva,
      descricao: operacaoSelecionada.descricao,
      valor: valorPagamentoTemp,
      icon: operacaoSelecionada.icon,
      idcontadestino: idContaDestinoEfetiva,
      contaDestinoLabel: contaDestinoLabelEfetiva,
    };
    setFormasPagamentoSelecionadas(prev => [...prev, novaForma]);
    setValorPagamentoTemp(0);
    setIdContaDestinoTemp('');
    setContaDestinoLabelTemp('');
    setTipoCartao('credito');
    setTipoPix('estatico');
    setTimeout(() => { selectRef.current?.focus(); }, 100);
  };

  const removerFormaPagamento = (id: string) => {
    setFormasPagamentoSelecionadas(prev => prev.filter(item => item.id !== id));
  };

  const editarValorFormaPagamento = (id: string, novoValor: number) => {
    if (novoValor <= 0) { removerFormaPagamento(id); return; }
    const outrasFormas = formasPagamentoSelecionadas.filter(item => item.id !== id);
    const totalOutras = outrasFormas.reduce((acc, item) => acc + item.valor, 0);
    if (totalOutras + novoValor > totalFinal + 0.01) { setTms('warning'); setMsg(`Valor excede o total da venda. Limite máximo: ${formatarMoeda(totalFinal - totalOutras)}`); setOpenmsg(true); return; }
    setFormasPagamentoSelecionadas(prev => prev.map(item => item.id === id ? { ...item, valor: novoValor } : item));
  };

  useEffect(() => {
    if (!open) { resetForm(); setListaParcelas([]); setFormasPagamentoSelecionadas([]); setValorPagamentoTemp(0); setDesconto(0); setAcrescimo(0); }
  }, [open]);

  const finalizarVenda = useCallback(() => {
    // Duplo-clique ou F12 repetido enquanto a gravação anterior ainda está
    // em andamento — ver comentário de enviandoVendaRef acima.
    if (enviandoVendaRef.current) return;
    const formData = formRef.current?.getData() as Partial<IFormData>;
    // Edição só cobre o caso comum (à vista, uma ou mais formas de
    // pagamento) — orçamento/prazo têm mecânica própria (parcelas, sem
    // lançamento de caixa) que EditarVendaPdv.ts não cobre; permitir editar
    // pra esses dois exigiria replicar aquela lógica toda só pra edição.
    if (estaEditandoVenda && (isOrcamento || tpag === 2)) { setTms('warning'); setMsg('Edição de venda só funciona com pagamento à vista — orçamento e venda a prazo não são suportados aqui.'); setOpenmsg(true); return; }
    if (!isOrcamento && formasPagamentoSelecionadas.length === 0 && tpag !== 2) { setTms('warning'); setMsg('Adicione pelo menos uma forma de pagamento!'); setOpenmsg(true); return; }
    if (!idplanodecontas) { setTms('warning'); setMsg('Selecione um plano de contas!'); setOpenmsg(true); return; }
    if (!isOrcamento && tpag === 2 && !idParceiroSelecionado) { setTms('warning'); setMsg('Selecione um parceiro!'); setOpenmsg(true); return; }
    if (!isOrcamento && tpag === 2 && idParceiroSelecionado === Environment.URL_IDPARCEIRO) { setTms('warning'); setMsg('Selecione um parceiro específico para vendas a prazo!'); setOpenmsg(true); return; }
    if (!isOrcamento && tpag !== 2 && !totalPagoSuficiente) { setTms('warning'); setMsg(`Valor pago (${formatarMoeda(totalPago)}) é insuficiente. Total: ${formatarMoeda(totalFinal)}`); setOpenmsg(true); return; }

    // Editando: a venda já existe — idProp É o idmov dela (ver
    // DialogVendapdv id={vendaEmEdicao?.idmov ?? 'novo'} em Pdv.tsx).
    const idmov = estaEditandoVenda ? idProp : uuidv4();
    let idOperacaoFinal = '';
    let formasPagamentoParaEnvio: IFormaPagamentoEnvio[] | undefined;
    if (isOrcamento) { idOperacaoFinal = operacaoSelecionada?.id || ''; }
    else if (tpag === 2) { const operacaoPrazo = OPERACOES.find(op => op.id === Environment.IDVENDAPRAZO); idOperacaoFinal = operacaoPrazo?.id || ''; formasPagamentoParaEnvio = [{ idoperacao: idOperacaoFinal, valor: totalFinal, nome: operacaoPrazo?.nome || '', categoria: operacaoPrazo?.nome || '' }]; }
    else {
      idOperacaoFinal = formasPagamentoSelecionadas[0]?.idoperacao || '';
      // `f.valor` é o valor TENDIDO pelo cliente (ex.: pagou com uma nota de
      // R$100 numa venda de R$70) — nunca pode ir inteiro pro caixa, senão o
      // troco devolvido vira "entrada" também, inflando o caixa pelo valor
      // do troco (ver `troco` acima, calculado a partir desse mesmo valor
      // tendido). Só a parcela que efetivamente cobre o que falta da venda
      // é enviada; o excedente (troco) é descartado aqui — o operador já viu
      // o troco calculado na tela antes de confirmar. Cada forma consome da
      // capacidade restante em ordem; a forma que estoura o total absorve só
      // a parte que falta, e qualquer forma seguinte (não deveria existir,
      // mas por segurança) fica com valor 0 e é descartada no filter.
      let capacidadeRestante = totalFinal;
      formasPagamentoParaEnvio = formasPagamentoSelecionadas
        .map((f) => {
          const valorReal = round(Math.max(0, Math.min(f.valor, capacidadeRestante)), 2);
          capacidadeRestante = round(Math.max(0, capacidadeRestante - valorReal), 2);
          return { idoperacao: f.idoperacao, valor: valorReal, nome: f.nome, categoria: f.nome, idcontadestino: f.idcontadestino };
        })
        .filter((f) => f.valor > 0);
    }

    const dadosParaEnvio: IFormData = { idmov, idparceiro: idParceiroSelecionado, idplanoconta: idplanodecontas, idoperacao: idOperacaoFinal, iduser, numero: '0', emissao: dayjs().format('YYYY-MM-DD HH:mm:ss'), vprod: totalItens, desconto: valorDesconto, acrescimo: valorAcrescimo, total: totalFinal, tipovenda: 'pdv', obs: formData.obs || '', formasPagamento: formasPagamentoParaEnvio };

    pagamentoSchema.validate(dadosParaEnvio, { abortEarly: false }).then((dadosValidados) => {
      const dadosComData = { ...dadosValidados, emissao: dayjs(dadosValidados.emissao).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss') };
      const totalProdutos = round((props.dadosItens || []).reduce((acc, item) => acc + Number(item.qtds) * Number(item.preco), 0));
      const itensFormatados = (props.dadosItens || []).map((item, index, array) => {
        const subtotalItem = round(Number(item.qtds) * Number(item.preco));
        // Proporção de rateio (não é valor monetário) — precisa de mais
        // casas que 2 pra não distorcer o rateio entre vários itens; o valor
        // final de cada item continua saindo arredondado a 2 (descontoItem/
        // acrescimoItem/totalItem abaixo usam o default de `round`).
        const percentualItem = totalProdutos > 0 ? round(subtotalItem / totalProdutos, 6) : 0;
        let descontoItem = round(valorDesconto * percentualItem);
        let acrescimoItem = round(valorAcrescimo * percentualItem);
        if (index === array.length - 1) {
          const descontoAcumulado = array.slice(0, -1).reduce((acc, it) => { const sub = round(Number(it.qtds) * Number(it.preco)); const proporcao = totalProdutos > 0 ? round(sub / totalProdutos, 6) : 0; return round(acc + round(valorDesconto * proporcao)); }, 0);
          const acrescimoAcumulado = array.slice(0, -1).reduce((acc, it) => { const sub = round(Number(it.qtds) * Number(it.preco)); const proporcao = totalProdutos > 0 ? round(sub / totalProdutos, 6) : 0; return round(acc + round(valorAcrescimo * proporcao)); }, 0);
          descontoItem = round(valorDesconto - descontoAcumulado);
          acrescimoItem = round(valorAcrescimo - acrescimoAcumulado);
        }
        const totalItem = round(subtotalItem + acrescimoItem - descontoItem);
        return { iditens: item.iditens, idprodutos: item.idprodutos, idref: '', filtro: '', qtds: Number(item.qtds), qtde: 0, preco: round(Number(item.preco), 2), descricao: item.descricao, marca: item.marca, referencia: item.referencia, un: item.un, desconto: round(descontoItem, 2), voutros: round(acrescimoItem, 2), subtotal: round(subtotalItem, 2), total: round(totalItem, 2) };
      });

      if (idProp === 'novo') {
        if (tpag === 2) {
          const totalParcelasSum = listaParcelas.reduce((acc, p) => acc + p.vparcela, 0);
          if (Math.abs(totalParcelasSum - totalFinal) > 0.01) { setTms('error'); setMsg('Total das parcelas não confere com o total da venda'); setOpenmsg(true); return; }
        }
        enviandoVendaRef.current = true;
        setIsLoading(true);
        setLoadingMessageVenda('Gravando venda...');
        VendasService.createpdv(dadosComData, itensFormatados, tpag === 2 ? listaParcelas : []).then(async (result) => {
          if (result instanceof Error) { enviandoVendaRef.current = false; pararProgressoComErro(); setTms('error'); setMsg(result.message); setOpenmsg(true); }
          else {
            const salvaOffline = !!(await impressaoVendaOffline(result));
            setTms('success');
            setMsg(salvaOffline ? 'Venda salva neste computador (offline) — será enviada ao servidor quando a internet voltar.' : 'Lançamento Realizado com sucesso!');
            setOpenmsg(true);
            setUltimaFormaPagamentoVenda(formasPagamentoSelecionadas[0]?.nome || '');
            setUltimoResumoPagamento({
              formas: formasPagamentoSelecionadas.map((f) => ({ nome: f.nome, valor: f.valor })),
              totalPago,
              totalFinal,
              nomeParceiro: nomeParceiroSelecionado,
              aPrazo: tpag === 2,
              qtdParcelas: tpag === 2 ? listaParcelas.length : 0,
            });
            resetForm();
            setIdVendaImpressao(dadosComData.idmov);
            setVendaConcluidaComSucesso(true);
            setUltimaVendaOrcamento(isOrcamento);
            // Preview ligado: vai gerar o PDF de verdade (mais demorado,
            // rótulo próprio). Preview desligado (vai direto pra NFC-e):
            // handleImpressao só abre a dialog de emissão e volta na hora,
            // então o rótulo continua sendo sobre a venda em si.
            setLoadingMessageVenda(previewImpressao ? 'Gerando PDF...' : 'Preparando emissão da NFC-e...');
            await handleImpressao(dadosComData.idmov, isOrcamento);
            concluirProgressoComSucesso();
          }
        }).catch((error) => { enviandoVendaRef.current = false; pararProgressoComErro(); setTms('error'); setMsg(error.message || 'Erro ao realizar a venda'); setOpenmsg(true); });
      } else {
        // Editando — não grava nada ainda. Monta o payload (mesmos cálculos
        // de sempre: rateio de desconto/acréscimo por item, troco já
        // descontado das formas de pagamento) e abre a autorização; o
        // UPDATE de verdade só acontece se/quando confirmar usuário+senha
        // (ver handleConfirmarEdicao/DialogAutorizacaoGerente abaixo).
        setPendingEdicao({
          idoperacao: idOperacaoFinal,
          vprod: totalItens,
          desconto: valorDesconto,
          acrescimo: valorAcrescimo,
          total: totalFinal,
          itens: itensFormatados.map((item) => ({
            iditens: item.iditens,
            idprodutos: item.idprodutos,
            un: item.un,
            qtde: item.qtde,
            qtds: item.qtds,
            preco: item.preco,
            desconto: item.desconto,
            voutros: item.voutros,
            subtotal: item.subtotal,
            total: item.total,
          })),
          formasPagamento: (formasPagamentoParaEnvio || []).map((forma) => ({
            idoperacao: forma.idoperacao,
            valor: forma.valor,
            categoria: forma.categoria,
            idcontadestino: forma.idcontadestino,
          })),
        });
        setOpenAutorizacaoEdicao(true);
      }
    }).catch((errors: yup.ValidationError) => {
      const validationErrors: any = {};
      errors.inner.forEach(error => { if (!error.path) return; validationErrors[error.path] = error.message; });
      formRef.current?.setErrors(validationErrors);
      if (errors.inner.length > 0) { setTms('error'); setMsg(errors.inner[0].message); setOpenmsg(true); }
    });
  }, [formasPagamentoSelecionadas, tpag, totalPagoSuficiente, idParceiroSelecionado, totalFinal, totalItens, valorDesconto, valorAcrescimo, iduser, idplanodecontas, idProp, estaEditandoVenda, listaParcelas, props.dadosItens, tipoPagamentoFat, qtdParcelas, isOrcamento, operacaoSelecionada, previewImpressao]);

  // Autorização confirmada (usuário+senha conferidos e com permissão,
  // update já gravado no servidor, ver EditarVendaPdv.ts) — fecha tudo e
  // avisa Pdv.tsx como um "success" normal, que já limpa o carrinho e o
  // modo de edição (ver iniciarNovaVenda/vendaEmEdicao em Pdv.tsx).
  const handleEdicaoAutorizada = useCallback(() => {
    setOpenAutorizacaoEdicao(false);
    setPendingEdicao(null);
    enviandoVendaRef.current = false;
    const mensagem = `✏️ Venda #${numeroVendaEmEdicao || ''} atualizada com sucesso!`;
    if (props.onMensagemSucesso) props.onMensagemSucesso(mensagem);
    else { setTms('success'); setMsg(mensagem); setOpenmsg(true); }
    onClose('success');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numeroVendaEmEdicao, onClose]);

  const handleQtdParcelasChange = useCallback((valor: string | undefined) => {
    if (!valor || valor === '') { if (qtdParcelas !== 1) { setQtdParcelas(1); formRef.current?.setFieldValue('qtdparcelas', 1); } return; }
    let novaQtd = Number(valor) || 1;
    if (isNaN(novaQtd) || novaQtd < 1) novaQtd = 1;
    if (novaQtd > MAX_PARCELAS) { setTms('warning'); setMsg(`Máximo de ${MAX_PARCELAS} parcelas permitidas!`); setOpenmsg(true); novaQtd = MAX_PARCELAS; setTimeout(() => { formRef.current?.setFieldValue('qtdparcelas', MAX_PARCELAS); }, 0); }
    if (novaQtd !== qtdParcelas) { setQtdParcelas(novaQtd); formRef.current?.setFieldValue('qtdparcelas', novaQtd); }
  }, [qtdParcelas]);

  useEffect(() => {
    if (tpag === 2) { setQtdParcelas(1); setTipoPagamentoFat('boleto'); setTimeout(() => { formRef.current?.setFieldValue('qtdparcelas', 1); formRef.current?.setFieldValue('pagamento', 'boleto'); }, 0); }
  }, [tpag]);

  useEffect(() => {
    if (tpag !== 2) { setListaParcelas([]); return; }
    let parcelasLimitadas = Math.max(1, qtdParcelas);
    if (parcelasLimitadas > MAX_PARCELAS) { parcelasLimitadas = MAX_PARCELAS; if (qtdParcelas !== MAX_PARCELAS) { setQtdParcelas(MAX_PARCELAS); formRef.current?.setFieldValue('qtdparcelas', MAX_PARCELAS); } return; }
    if (qtdParcelas < 1) { setQtdParcelas(1); formRef.current?.setFieldValue('qtdparcelas', 1); return; }
    if (parcelasLimitadas > 100) setGerandoParcelas(true);
    const timeoutId = setTimeout(() => {
      // divisão mantida em precisão total; o arredondamento para centavos só ocorre
      // na atribuição de cada parcela, e o acumulado usa esse valor já em centavos —
      // assim a última parcela absorve exatamente a diferença de arredondamento.
      const valorParcelaRaw = totalFinal / parcelasLimitadas;
      let acumulado = 0;
      const novasParcelas: IParcelasFaturamento[] = [];
      for (let i = 0; i < parcelasLimitadas; i++) {
        const isLast = i === parcelasLimitadas - 1;
        const valorParcelaAtual = isLast ? round(totalFinal - acumulado, 2) : round(valorParcelaRaw, 2);
        acumulado = round(acumulado + valorParcelaAtual, 2);
        novasParcelas.push({ idrec: uuidv4(), idplanoconta: idplanodecontas, idparceiro: idParceiroSelecionado, emissao: dayjs().format('YYYY-MM-DD HH:mm:ss'), pagamento: tipoPagamentoFat, vencimento: dayjs().add(30 + i * 30, 'day').format('YYYY-MM-DD'), vparcela: valorParcelaAtual, venda: round(totalFinal, 2), parcela: `${i + 1}/${parcelasLimitadas}`, vrecebido: 0, historico: 'venda pdv', vreceber: valorParcelaAtual, tipo: 1, desconto: 0, juros: 0, acrescimo: 0, qtdparcelas: parcelasLimitadas });
      }
      setListaParcelas(novasParcelas);
      setGerandoParcelas(false);
    }, 0);
    return () => clearTimeout(timeoutId);
  }, [qtdParcelas, tipoPagamentoFat, totalFinal, tpag, idParceiroSelecionado, idplanodecontas]);

  const handleTipopagamento = (valor: string | undefined) => {
    if (valor != null) { setTipoPagamentoFat(valor); formRef.current?.setFieldValue('pagamento', valor); }
  };

  const handleImpressaoCaixa = async (id: string) => {
    const result = await VendasService.Impressao(id);
    if (!(result instanceof Error)) { const pdfBlob = await PDFVenda01(result, ultimaVendaOrcamento); if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl); setPdfBlobUrl(URL.createObjectURL(pdfBlob)); }
  };

  const handleImpressaoTermica = async (id: string) => {
    const result = await VendasService.Impressao(id);
    if (!(result instanceof Error)) { const pdfBlob = await PDFVendaTermica(result, ultimaVendaOrcamento); if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl); setPdfBlobUrl(URL.createObjectURL(pdfBlob)); }
  };
  const handleParceiro = (parceiro: string | undefined) => setIdParceiroSelecionado(parceiro ?? '');
  const handleParceiroCriado = (idparceiro: string, nome: string) => {
    handleParceiro(idparceiro);
    formRef.current?.setFieldValue('idparceiro', idparceiro);
    setOpenNovoParceiroDialog(false);
    setTms('success');
    setMsg(`Cliente ${nome} adicionado à venda!`);
    setOpenmsg(true);
    setNomeParceiroSelecionado(nome);
  };
  const handleParceiroSelecionado = (idparceiro: string, nome: string) => {
    handleParceiro(idparceiro);
    formRef.current?.setFieldValue('idparceiro', idparceiro);
    setNomeParceiroSelecionado(nome);
    setOpenSelecionarParceiroDialog(false);
    setTms('success');
    setMsg(`Cliente ${nome} selecionado para a venda!`);
    setOpenmsg(true);
  };
  const handleConfirmarEmitirNota = () => { setOpenNotaFiscalDialog(false); setOpenCpfDialog(true); };
  const handleCancelarEmitirNota = () => { setOpenNotaFiscalDialog(false); setSelectedTotal(totalFinal); };
  // Cancelar/ESC/X da tela de finalizar venda — se a venda já tinha sido
  // concluída (preview desligado, operador voltou aqui depois de fechar a
  // nota sem emitir, ver handleCloseNfceDialog), sair agora é que fecha de
  // vez e reseta a tela pra uma venda nova ('success' já faz isso em
  // handleCloseDialog, Pdv.tsx). Se ainda não tinha concluído, comportamento
  // de sempre (fecha sem mexer no carrinho).
  //
  // Bloqueado enquanto isLoading (gravando a venda) — fechar a dialog não
  // cancela a requisição em andamento; ela continua rodando e, se terminar
  // com sucesso DEPOIS de fechada, ainda dispara o fluxo de sucesso (que
  // zera o carrinho em Pdv.tsx) — um "carrinho zerou sozinho" bem depois do
  // clique, sem o operador entender por quê. Travar o fechamento até a
  // gravação terminar evita esse cenário.
  const handleClose = () => {
    if (isLoading) return;
    resetForm();
    onClose?.(vendaConcluidaComSucesso ? 'success' : undefined);
  };
  // Erro só some quando o operador clica em fechar de verdade — nem sozinho
  // por tempo (ver autoHideDuration do Snackbar, que não se aplica a erro)
  // nem clicando fora sem querer (reason 'clickaway').
  const handleCloseMsg = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpenmsg(false);
  };

  // Sucesso não flutua na tela: vai pro header do PDV (onMensagemSucesso).
  const sucessoNoHeader = tms === 'success' && !!props.onMensagemSucesso;
  useEffect(() => {
    if (openmsg && sucessoNoHeader) {
      props.onMensagemSucesso?.(msg);
      setOpenmsg(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openmsg, sucessoNoHeader, msg]);

  const totalParcelas = listaParcelas.reduce((acc, item) => acc + item.vparcela, 0);
  const diferenca = totalParcelas - totalFinal;

  const handleParcelaValueChange = useCallback((id: string, valor: string) => {
    setListaParcelas(prevLista => {
      const index = prevLista.findIndex(item => item.idrec === id);
      if (index === -1) return prevLista;
      const novaLista = [...prevLista];
      const valorNumerico = round(Number(valor) || 0, 2);
      novaLista[index] = { ...novaLista[index], vparcela: valorNumerico, vreceber: valorNumerico };
      return novaLista;
    });
  }, []);

  // Enter no valor: Cartão/PIX pulam pro toggle de Crédito/Débito ou
  // Estático/Dinâmico antes de adicionar — as outras formas (Dinheiro etc.)
  // adicionam direto, como sempre.
  const handleValorKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    if (precisaTipoCartao) { tipoCartaoToggleRef.current?.focus(); return; }
    if (precisaTipoPix) { tipoPixToggleRef.current?.focus(); return; }
    adicionarFormaPagamento();
  };

  // Esquerda/Direita alternam entre Crédito/Débito (só 2 opções, então
  // qualquer uma das duas setas inverte a escolha — o MUI ToggleButtonGroup
  // não faz esse roving sozinho) e movem o foco visual pro botão
  // correspondente; Enter adiciona direto, os dois roteiam sozinhos pra
  // recebível fixa (sem conta pra escolher).
  const handleEnterNoTipoCartao = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      const proximo = tipoCartao === 'credito' ? 'debito' : 'credito';
      setTipoCartao(proximo);
      const botoes = event.currentTarget.querySelectorAll<HTMLButtonElement>('button');
      (proximo === 'credito' ? botoes[0] : botoes[1])?.focus();
      return;
    }
    if (event.key !== 'Enter') return;
    event.preventDefault();
    adicionarFormaPagamento();
  };

  // Mesma navegação por setas do toggle de Cartão, aplicada ao Estático/
  // Dinâmico. Enter no toggle Estático/Dinâmico: Estático pula pra conta
  // bancária (precisa saber qual), Dinâmico adiciona direto (recebível fixa).
  const handleEnterNoTipoPix = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      const proximo = tipoPix === 'estatico' ? 'dinamico' : 'estatico';
      setTipoPix(proximo);
      const botoes = event.currentTarget.querySelectorAll<HTMLButtonElement>('button');
      (proximo === 'estatico' ? botoes[0] : botoes[1])?.focus();
      return;
    }
    if (event.key !== 'Enter') return;
    event.preventDefault();
    // Estático com conta padrão configurada não tem campo pra focar (ver
    // precisaContaDestino) — adiciona direto, igual Dinâmico.
    if (tipoPix === 'estatico' && !temContaPadraoPix) contaDestinoInputRef.current?.focus();
    else adicionarFormaPagamento();
  };

  const handleVencimentoChange = (index: number, newValue: dayjs.Dayjs | null) => {
    const novaLista = [...listaParcelas];
    novaLista[index].vencimento = dayjs(newValue).format('YYYY-MM-DD');
    setListaParcelas(novaLista);
  };

  // Preview desligado + venda já concluída nesta sessão da tela (operador
  // fechou a nota sem emitir e voltou aqui, ver handleCloseNfceDialog) — o
  // botão principal (e o atalho F12) reabrem a MESMA emissão em vez de
  // tentar finalizar a venda de novo (que criaria uma venda duplicada).
  const podeReabrirNfce = vendaConcluidaComSucesso && !previewImpressao;

  useEffect(() => {
    const handleKeys = (event: KeyboardEvent) => {
      if (!open) return;
      // Nota fiscal (ou a tela de visualizar/reimprimir) aberta por cima —
      // F12/setas agem nela (cada uma já trata seu próprio teclado), não
      // aqui embaixo; sem essa exclusão os dois listeners globais
      // disparavam juntos no mesmo F12.
      if (openDialogNfce || openPdfViewer) return;
      // Mesma coisa pros diálogos menores abertos por cima da venda
      // (desconto/acréscimo, parceiro, CPF, "emitir nota?"): cada um trata o
      // próprio Enter (ex.: desconto navega valor → % → acréscimo → % →
      // Confirmar) — sem essa exclusão, este listener (capture phase, roda
      // antes deles) engolia o Enter e jogava o foco de volta pro campo de
      // valor do pagamento.
      if (openDescontoDialog || openSelecionarParceiroDialog || openNovoParceiroDialog || openCpfDialog || openNotaFiscalDialog) return;
      // Venda já concluída (tela travada, ver podeReabrirNfce) — só F12
      // (reabrir a nota) continua ativo; setas/Enter/F9 não têm mais o que
      // fazer (o formulário de pagamento nem está mais na tela).
      if (podeReabrirNfce && event.key !== 'F12') return;
      // Mesma exclusão do Enter (ver comentário mais abaixo) — sem ela, esse
      // listener global (capture phase, roda antes do Autocomplete de
      // Parceiro tratar a própria seta) sempre ganhava e trocava a operação
      // selecionada em vez de deixar o foco navegar pela listagem de
      // parceiros/campo de valor/toggles.
      const focoEmCampoProprio = document.activeElement === valorRef.current
        || document.activeElement === parceiroRef.current
        || document.activeElement === tipoCartaoToggleRef.current
        || document.activeElement === tipoPixToggleRef.current
        || document.activeElement === contaDestinoInputRef.current
        || (document.activeElement instanceof HTMLElement && document.activeElement.closest('.MuiToggleButtonGroup-root'));

      if (event.key === 'ArrowUp') {
        if (focoEmCampoProprio) return;
        event.preventDefault(); event.stopPropagation();
        selecionarOperacao(Math.max(0, operacaoSelecionadaIndex - 1), false);
        return;
      }
      if (event.key === 'ArrowDown') {
        if (focoEmCampoProprio) return;
        event.preventDefault(); event.stopPropagation();
        selecionarOperacao(Math.min(OPERACOES.length - 1, operacaoSelecionadaIndex + 1), false);
        return;
      }
      if (
        event.key === 'Enter'
        && !focoEmCampoProprio
        // Toggle Crédito/Débito, Estático/Dinâmico e o campo de conta
        // bancária (PIX Estático) também tratam o próprio Enter (ver
        // handleEnterNoTipoCartao/handleEnterNoTipoPix e o onKeyDown do
        // AutoCompleteContaBancariaSimple) — sem essa exclusão, esse
        // listener global (capture phase, roda antes de qualquer handler
        // local) sempre ganhava e reselecionava a operação em vez de
        // avançar o fluxo.
      ) {
        event.preventDefault(); event.stopPropagation();
        selecionarOperacao(operacaoSelecionadaIndex, true);
        return;
      }
      if (event.key === 'F12') {
        event.preventDefault();
        if (podeReabrirNfce) { setUltimoIdmovCriado(idVendaImpressao); setOpenDialogNfce(true); }
        else finalizarVenda();
      }
      if (event.key === 'F9' && !podeReabrirNfce) { event.preventDefault(); setOpenDescontoDialog(true); }
    };
    window.addEventListener('keydown', handleKeys, true);
    return () => window.removeEventListener('keydown', handleKeys, true);
  }, [
    open, finalizarVenda, operacaoSelecionadaIndex, openDialogNfce, openPdfViewer, podeReabrirNfce, idVendaImpressao,
    openDescontoDialog, openSelecionarParceiroDialog, openNovoParceiroDialog, openCpfDialog, openNotaFiscalDialog,
  ]);

  // ─── Estilo das colunas ──────────────────────────────────────────────────────
  const colStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
  };

  const sectionLabel = {
    fontSize: '11px',
    fontWeight: 600,
    color: theme.palette.text.disabled,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
    mb: 1,
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 250 }}
        sx={{
          '& .MuiDialog-paper': {
            position: 'relative',
            borderRadius: '16px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
            background: theme.palette.background.default,
            overflow: 'hidden',
            width: '100%',
            maxWidth: 760,
            maxHeight: '92vh',
            display: 'flex',
            flexDirection: 'column',
            transition: 'max-width 0.22s ease',
            '& *::-webkit-scrollbar': { width: 6, height: 6 },
            '& *::-webkit-scrollbar-track': { background: 'transparent' },
            '& *::-webkit-scrollbar-thumb': {
              backgroundColor: isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.18)',
              borderRadius: 4,
            },
            '& *': { scrollbarWidth: 'thin', scrollbarColor: `${isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.18)'} transparent` },
            // No celular a margem padrão do MUI (32px de cada lado) some quase
            // toda a largura útil — vira uma margem pequena e fixa, com a
            // altura máxima um pouco maior (menos espaço perdido ao redor).
            [MQ_PHONE]: {
              margin: '8px',
              width: 'calc(100% - 16px)',
              maxHeight: '95vh',
              borderRadius: '12px',
            },
          },
        }}
      >
        {/* Loading — filho do próprio Paper do Dialog (position:relative
            acima), não um Backdrop solto por fora dele. Um Backdrop
            separado (mesmo com z-index bem alto) ainda dependia de
            empilhamento entre dois elementos different — na prática
            continuava renderizando atrás do Dialog às vezes. Sendo filho
            do mesmo Paper, pinta por cima de tudo que vem antes dele aqui
            dentro, sem depender de z-index nem de portal nenhum. */}
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              zIndex: 20,
              backgroundColor: 'rgba(0, 0, 0, 0.85)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
            }}
          >
            <SpinningLogo />
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 500, textAlign: 'center' }}>
              {loadingMessageVenda}
            </Typography>
            {/* Percentual simulado (ver progressoVenda) — a API não manda
                progresso de verdade, mas o operador precisa de ALGUM
                feedback de que a tela travada está avançando, não travada
                de vez. */}
            <Box sx={{ width: 280, maxWidth: '80vw', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <LinearProgress
                variant="determinate"
                value={progressoVenda}
                sx={{
                  width: '100%',
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  '& .MuiLinearProgress-bar': { borderRadius: 4, backgroundColor: '#fff' },
                }}
              />
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.85)', fontWeight: 700 }}>
                {Math.round(progressoVenda)}%
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', textAlign: 'center' }}>
              Aguarde enquanto processamos sua solicitação...
            </Typography>
          </Box>
        )}

        {/* ── HEADER ── */}
        <Box
          sx={{
            px: 2.5,
            py: 1.75,
            borderBottom: `0.5px solid ${borderColor}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
            bgcolor: theme.palette.background.paper,
            [MQ_PHONE]: {
              px: 1.5,
              py: 1,
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: '8px',
                background: colors.primaryGradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <PaymentIcon sx={{ fontSize: 20, color: colors.textOnPrimary }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle1" fontWeight={600} lineHeight={1.2} noWrap>
                {podeReabrirNfce ? 'Venda concluída' : 'Finalizar venda'}
              </Typography>
              {/* Atalhos de teclado (setas/F9/F12...) não fazem sentido no
                  celular (sem teclado físico) — some no MQ_PHONE, sobra só a
                  contagem de itens. */}
              <Typography variant="caption" sx={{ color: 'text.secondary', [MQ_PHONE]: { display: 'none' } }}>
                {podeReabrirNfce ? (
                  <>{quantidadeItens} {quantidadeItens === 1 ? 'item' : 'itens'} · <KbdChip label="F12" /> emitir NFC-e · <KbdChip label="Esc" /> nova venda</>
                ) : (
                  <>
                    {quantidadeItens} {quantidadeItens === 1 ? 'item' : 'itens'} ·
                    <KbdChip label="↑↓" /> navegar ·
                    <KbdChip label="1–4" /> forma ·
                    <KbdChip label="Enter" /> pagar ·
                    <KbdChip label="F9" /> desconto ·
                    <KbdChip label="F12" /> finalizar
                  </>
                )}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', display: 'none', [MQ_PHONE]: { display: 'block' } }}>
                {quantidadeItens} {quantidadeItens === 1 ? 'item' : 'itens'}
              </Typography>
            </Box>
          </Box>

          {/* Cliente/Desconto só fazem sentido ANTES de concluir a venda —
              depois (podeReabrirNfce) a tela fica toda travada, só sobra
              Emitir NFC-e/Fechar no rodapé. */}
          {!podeReabrirNfce && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, [MQ_PHONE]: { gap: 0.5 } }}>
              <Tooltip title={nomeParceiroSelecionado ? `Cliente: ${nomeParceiroSelecionado}` : 'Selecionar cliente'}>
                <IconButton
                  size="small"
                  onClick={() => setOpenSelecionarParceiroDialog(true)}
                  sx={{
                    width: 36,
                    height: 36,
                    color: colors.primarySolid,
                    bgcolor: isDark ? alpha(colors.primarySolid, 0.18) : alpha(colors.primarySolid, 0.09),
                    '&:hover': { bgcolor: isDark ? alpha(colors.primarySolid, 0.28) : alpha(colors.primarySolid, 0.16) },
                    [MQ_PHONE]: { width: 32, height: 32 },
                  }}
                >
                  <PersonIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Desconto / acréscimo (F9)">
                <IconButton
                  size="small"
                  onClick={() => setOpenDescontoDialog(true)}
                  sx={{
                    width: 36,
                    height: 36,
                    color: colors.primarySolid,
                    bgcolor: isDark ? alpha(colors.primarySolid, 0.18) : alpha(colors.primarySolid, 0.09),
                    '&:hover': { bgcolor: isDark ? alpha(colors.primarySolid, 0.28) : alpha(colors.primarySolid, 0.16) },
                    [MQ_PHONE]: { width: 32, height: 32 },
                  }}
                >
                  <PercentIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>

        {/* ── CONTENT ── */}
        <DialogContent sx={{ p: 0, display: 'flex', flex: 1, minHeight: 0, overflowY: 'auto' }}>
          {podeReabrirNfce ? (
            /* Venda já concluída (preview desligado, ver podeReabrirNfce) —
               tela toda travada: nada do formulário de pagamento aparece
               mais (nem "falta pagar", que não faz sentido depois que os
               dados de pagamento já foram zerados), só o resumo de como foi
               pago. Só sai daqui pelo rodapé (Emitir NFC-e / Fechar). */
            <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2.5, width: '100%', [MQ_PHONE]: { p: 2 } }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  p: 2,
                  borderRadius: 2,
                  bgcolor: isDark ? 'rgba(46,125,50,0.15)' : 'rgba(46,125,50,0.08)',
                  border: `0.5px solid ${isDark ? 'rgba(46,125,50,0.35)' : 'rgba(46,125,50,0.2)'}`,
                }}
              >
                <CheckCircleIcon sx={{ color: 'success.main', fontSize: 28, flexShrink: 0 }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight={700} color="success.main">
                    {ultimaVendaOrcamento ? 'Orçamento registrado' : 'Venda concluída'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Emita a nota fiscal ou feche a tela pra começar uma venda nova.
                  </Typography>
                </Box>
              </Box>

              {!!ultimoResumoPagamento?.nomeParceiro && (
                <Box>
                  <Typography sx={sectionLabel}>Cliente</Typography>
                  <Typography variant="body2" fontWeight={600}>{ultimoResumoPagamento.nomeParceiro}</Typography>
                </Box>
              )}

              <Box>
                <Typography sx={sectionLabel}>Como foi pago</Typography>
                {ultimoResumoPagamento?.aPrazo ? (
                  <Typography variant="body2">
                    Venda a prazo — {ultimoResumoPagamento.qtdParcelas} {ultimoResumoPagamento.qtdParcelas === 1 ? 'parcela' : 'parcelas'}
                  </Typography>
                ) : ultimoResumoPagamento?.formas.length ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                    {ultimoResumoPagamento.formas.map((forma, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          px: 1.5,
                          py: 1,
                          borderRadius: '8px',
                          bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
                        }}
                      >
                        <Typography variant="body2">{forma.nome}</Typography>
                        <Typography variant="body2" fontWeight={700}>{formatarMoeda(forma.valor)}</Typography>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">Orçamento — sem pagamento.</Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 1.5,
                  py: 1.25,
                  borderRadius: '8px',
                  bgcolor: alpha(colors.primarySolid, 0.1),
                }}
              >
                <Typography variant="subtitle2" fontWeight={700}>Total pago</Typography>
                <Typography variant="subtitle1" fontWeight={700} sx={{ color: colors.primarySolid }}>
                  {formatarMoeda(ultimoResumoPagamento?.totalPago ?? 0)}
                </Typography>
              </Box>
            </Box>
          ) : (
          <Form ref={formRef} onSubmit={() => {}} style={{ width: '100%', flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '190px 1fr 230px',
                width: '100%',
                minHeight: 380,
                // No celular as 3 colunas (largura fixa em px, não cabem
                // lado a lado numa tela de ~360-400px) empilham em vez de
                // ficar lado a lado: forma de pagamento, depois
                // valor/parcelamento, depois o resumo/total — nessa ordem,
                // que já é a ordem natural do DOM.
                [MQ_PHONE]: {
                  gridTemplateColumns: '1fr',
                  minHeight: 'auto',
                },
              }}
            >

              {/* ── COL 1: Formas de pagamento ── */}
              <Box
                sx={{
                  borderRight: `0.5px solid ${borderColor}`,
                  ...colStyle,
                  [MQ_PHONE]: {
                    borderRight: 'none',
                    borderBottom: `0.5px solid ${borderColor}`,
                    height: 'auto',
                  },
                }}
              >
                <Typography sx={{ ...sectionLabel, px: 2, pt: 2 }}>
                  Forma de pagamento
                </Typography>
                <Box
                  ref={selectRef}
                  tabIndex={0}
                  onKeyDown={handleKeyDownOpcoes}
                  sx={{ outline: 'none', flex: 1, overflow: 'auto' }}
                >
                  {OPERACOES.map((op, index) => {
                    const isActive = operacaoSelecionadaIndex === index;
                    return (
                      <Box
                        key={op.id}
                        ref={(el: HTMLDivElement | null) => { listItemRefs.current[index] = el; }}
                        onClick={() => selecionarOperacao(index)}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.25,
                          px: 2,
                          py: 1.25,
                          cursor: 'pointer',
                          borderLeft: `2px solid ${isActive ? colors.primarySolid : 'transparent'}`,
                          bgcolor: isActive
                            ? isDark ? alpha(colors.primarySolid, 0.18) : alpha(colors.primarySolid, 0.09)
                            : 'transparent',
                          transition: 'background 0.12s',
                          '&:hover': {
                            bgcolor: isActive
                              ? isDark ? alpha(colors.primarySolid, 0.24) : alpha(colors.primarySolid, 0.14)
                              : isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
                          },
                        }}
                      >
                        {/* ícone */}
                        <Box
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: isActive ? colors.primarySolid : isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
                            color: isActive ? colors.textOnPrimary : 'text.secondary',
                            flexShrink: 0,
                            fontSize: 18,
                          }}
                        >
                          {op.icon}
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight={isActive ? 600 : 400}
                          sx={{ flex: 1, color: isActive ? colors.primarySolid : 'text.primary' }}
                        >
                          {op.nome}
                        </Typography>
                        {/* atalho numérico */}
                        <KbdChip label={String(index + 1)} />
                      </Box>
                    );
                  })}
                </Box>
              </Box>

              {/* ── COL 2: Valor + Pagamentos / Parcelamento ── */}
              <Box
                sx={{
                  borderRight: `0.5px solid ${borderColor}`,
                  display: 'flex',
                  flexDirection: 'column',
                  p: 2,
                  gap: 1.5,
                  overflow: 'hidden',
                  [MQ_PHONE]: {
                    borderRight: 'none',
                    borderBottom: `0.5px solid ${borderColor}`,
                    p: 1.5,
                    overflow: 'visible',
                  },
                }}
              >
                {isOrcamento ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 1, p: 3, textAlign: 'center' }}>
                    <RequestQuoteIcon sx={{ fontSize: 40, color: colors.primarySolid }} />
                    <Typography variant="body2" fontWeight={600}>
                      Orçamento sem pagamento
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Nenhum valor precisa ser informado. Clique em "Finalizar venda" para gerar o orçamento.
                    </Typography>
                  </Box>
                ) : tpag !== 2 ? (
                  <>
                    <Typography sx={sectionLabel}>Valor recebido</Typography>

                    {/* input + botão */}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <VFieldMoney2ValorItem
                        inputRef={valorRef}
                        fullWidth
                        size="small"
                        id="valorPagamento"
                        label="Valor"
                        value={String(valorPagamentoTemp)}
                        onKeyDown={handleValorKeyDown}
                        valor={handleValorPagamentoChange}
                        sx={{ '& .MuiInputBase-root': { height: 40, fontSize: 15 } }}
                      />
                      <Button
                        variant="contained"
                        onClick={adicionarFormaPagamento}
                        sx={{
                          height: 40,
                          minWidth: 48,
                          px: 1.5,
                          flexShrink: 0,
                          background: colors.primaryGradient,
                          color: colors.textOnPrimary,
                          '&:hover': { background: colors.hoverGradient },
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </Button>
                    </Box>

                    {/* Depois do valor: Cartão pede Crédito/Débito, PIX pede
                        Estático/Dinâmico — Enter no valor já foca aqui (ver
                        handleValorKeyDown). Os dois roteiam sozinhos pra
                        recebível fixa, exceto PIX Estático, que ainda pede a
                        conta bancária (QR Code fixo de uma conta). */}
                    {precisaTipoCartao && (
                      <ToggleButtonGroup
                        exclusive
                        size="small"
                        value={tipoCartao}
                        onChange={(_, valor) => { if (valor) setTipoCartao(valor); }}
                        onKeyDown={handleEnterNoTipoCartao}
                        fullWidth
                      >
                        <ToggleButton ref={tipoCartaoToggleRef} value="credito">Crédito</ToggleButton>
                        <ToggleButton value="debito">Débito</ToggleButton>
                      </ToggleButtonGroup>
                    )}
                    {precisaTipoPix && (
                      <ToggleButtonGroup
                        exclusive
                        size="small"
                        value={tipoPix}
                        onChange={(_, valor) => { if (valor) setTipoPix(valor); }}
                        onKeyDown={handleEnterNoTipoPix}
                        fullWidth
                      >
                        <ToggleButton ref={tipoPixToggleRef} value="estatico">Estático</ToggleButton>
                        <ToggleButton value="dinamico">Dinâmico</ToggleButton>
                      </ToggleButtonGroup>
                    )}
                    {precisaContaDestino && (
                      <AutoCompleteContaBancariaSimple
                        label="Conta bancária de destino"
                        tipo="banco"
                        value={idContaDestinoTemp}
                        inputRef={contaDestinoInputRef}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); adicionarFormaPagamento(); } }}
                        onChange={(id, label) => { setIdContaDestinoTemp(id); setContaDestinoLabelTemp(label ?? ''); }}
                      />
                    )}
                    {/* Conta travada em Configurações do PDV (F10) — sem
                        campo pra preencher, só um aviso de qual conta vai
                        receber (ver temContaPadraoPix). */}
                    {precisaTipoPix && tipoPix === 'estatico' && temContaPadraoPix && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.75,
                          px: 1.25,
                          py: 0.75,
                          borderRadius: '8px',
                          bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
                        }}
                      >
                        <AccountBalanceIcon sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }} />
                        <Typography variant="caption" color="text.secondary" noWrap>
                          Conta destino: <strong>{contaPadraoPix?.label}</strong>
                        </Typography>
                      </Box>
                    )}

                    {/* lista de pagamentos adicionados */}
                    <Box
                      sx={{
                        flex: 1,
                        border: `0.5px solid ${borderColor}`,
                        borderRadius: '8px',
                        overflow: 'auto',
                        minHeight: 100,
                      }}
                    >
                      {formasPagamentoSelecionadas.length === 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 0.5, p: 3 }}>
                          <PaymentIcon sx={{ fontSize: 30, color: 'text.disabled' }} />
                          <Typography variant="caption" color="text.disabled" align="center">
                            Selecione uma forma e adicione o valor
                          </Typography>
                        </Box>
                      ) : (
                        <List dense disablePadding>
                          {formasPagamentoSelecionadas.map((item) => (
                            <ListItem
                              key={item.id}
                              divider
                              sx={{ py: 0.75, px: 1.5 }}
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  size="small"
                                  onClick={() => removerFormaPagamento(item.id)}
                                  sx={{
                                    color: 'text.disabled',
                                    '&:hover': { color: 'error.main', bgcolor: 'error.light' },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              }
                            >
                              <ListItemAvatar>
                                <Avatar
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    bgcolor: isDark ? alpha(colors.primarySolid, 0.22) : alpha(colors.primarySolid, 0.1),
                                    color: colors.primarySolid,
                                  }}
                                >
                                  {item.icon}
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={<Typography variant="body2" fontWeight={500}>{item.nome}</Typography>}
                                secondary={item.contaDestinoLabel || undefined}
                                sx={{ flex: 1 }}
                              />
                              <VFieldMoney2Faturamento
                                id={item.id}
                                label=""
                                defaultValue={String(item.valor)}
                                valor={(id, valor) => editarValorFormaPagamento(id, Number(valor) || 0)}
                                size="small"
                                sx={{ width: 90, mr: 4, '& .MuiInputBase-root': { height: 30, fontSize: '0.85rem' } }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </Box>
                  </>
                ) : (
                  /* ── Parcelamento ── */
                  <>
                    <Typography sx={sectionLabel}>Parcelamento</Typography>

                    {/* filtros: parceiro / forma / qtd — agrupados num
                        cartão próprio, mesmo tratamento visual da tabela de
                        parcelas logo abaixo, pra separar claramente "quem
                        recebe/como" de "as parcelas em si". */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        p: 1.25,
                        mb: 1,
                        border: `0.5px solid ${borderColor}`,
                        borderRadius: '10px',
                        bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.012)',
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input': { fontSize: 13 },
                        '& .MuiInputLabel-root': { fontSize: 13, lineHeight: 1 },
                        '& .MuiInputLabel-root.MuiInputLabel-shrink': { fontSize: 13 },
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'flex-start' }}>
                        <Box sx={{ flex: 1 }}>
                          <AutoCompleteParceiro isExternalLoading={isLoading} uuidparceiro={handleParceiro} inputRef={parceiroRef} />
                        </Box>
                        <Tooltip title="Adicionar cliente à venda" arrow>
                          <IconButton
                            size="small"
                            onClick={() => setOpenNovoParceiroDialog(true)}
                            sx={{
                              height: 36,
                              width: 36,
                              borderRadius: '8px',
                              flexShrink: 0,
                              background: colors.primaryGradient,
                              color: colors.textOnPrimary,
                              '&:hover': { background: colors.hoverGradient },
                            }}
                          >
                            <PersonAddIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 0.75 }}>
                        <Box sx={{ flex: '1 1 62%' }}>
                          <BasicSelect
                            name="pagamento"
                            label="Forma"
                            data={[
                              { nameBD: 'boleto', descricao: 'Boleto' },
                              { nameBD: 'carteira', descricao: 'Carteira' },
                              { nameBD: 'deposito', descricao: 'Depósito' },
                              { nameBD: 'debitoemconta', descricao: 'Débito em conta' },
                              { nameBD: 'pix', descricao: 'PIX' },
                            ]}
                            aoClicar={handleTipopagamento}
                            disabled={false}
                          />
                        </Box>
                        <Box sx={{ flex: '1 1 38%' }}>
                          <VTextFieldNumber
                            fullWidth size="small" name="qtdparcelas" label="Qtd." defaultValue={1}
                            value={qtdParcelas} calcular={handleQtdParcelasChange}
                            inputProps={{ min: 1, max: MAX_PARCELAS, step: 1 }} disabled={gerandoParcelas}
                          />
                        </Box>
                      </Box>
                    </Box>

                    {Math.abs(diferenca) > 0.01 && (
                      <Alert severity={diferenca < 0 ? 'error' : 'warning'} sx={{ py: 0.25 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                          <Typography variant="caption">Venda: {formatarMoeda(totalFinal)}</Typography>
                          <Chip
                            size="small"
                            color={diferenca < 0 ? 'error' : 'warning'}
                            label={diferenca < 0 ? `Faltam ${formatarMoeda(Math.abs(diferenca))}` : `Excedem ${formatarMoeda(diferenca)}`}
                          />
                        </Box>
                      </Alert>
                    )}

                    {gerandoParcelas && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                        <CircularProgress size={20} />
                      </Box>
                    )}

                    {!gerandoParcelas && listaParcelas.length > 0 && (
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          border: `0.5px solid ${borderColor}`,
                          borderRadius: '10px',
                          overflow: 'hidden',
                          minHeight: 80,
                        }}
                      >
                        {/* cabeçalho da tabela */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                            px: 1.25,
                            py: 0.6,
                            borderBottom: `0.5px solid ${borderColor}`,
                            bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
                          }}
                        >
                          <Typography variant="caption" sx={{ flex: '1 1 auto', fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'text.disabled' }}>
                            Vencimento
                          </Typography>
                          <Typography variant="caption" sx={{ flex: '0 0 40px', fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'text.disabled', textAlign: 'center' }}>
                            Nº
                          </Typography>
                          <Typography variant="caption" sx={{ flex: '0 0 88px', fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'text.disabled', textAlign: 'right' }}>
                            Valor
                          </Typography>
                        </Box>

                        {/* linhas */}
                        <Box sx={{ flex: 1, overflow: 'auto' }}>
                          {listaParcelas.map((item, idx) => (
                            <Box
                              key={item.idrec}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                px: 1.25,
                                py: 0.5,
                                borderBottom: idx === listaParcelas.length - 1 ? 'none' : `0.5px solid ${borderColor}`,
                                transition: 'background 0.12s',
                                '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.025)' : 'rgba(0,0,0,0.015)' },
                                '& .MuiInputBase-root': { height: 30 },
                                '& .MuiInputBase-input': { fontSize: 12.5 },
                              }}
                            >
                              <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker
                                    format="DD/MM/YYYY"
                                    value={dayjs(item.vencimento)}
                                    onChange={(nv) => handleVencimentoChange(idx, nv)}
                                    slotProps={{ textField: { size: 'small', fullWidth: true, variant: 'standard' } }}
                                  />
                                </LocalizationProvider>
                              </Box>
                              <Box sx={{ flex: '0 0 40px', textAlign: 'center' }}>
                                <Typography variant="caption" color="text.secondary" fontWeight={500}>
                                  {idx + 1}/{listaParcelas.length}
                                </Typography>
                              </Box>
                              <Box sx={{ flex: '0 0 88px' }}>
                                <VFieldMoney2Faturamento
                                  id={item.idrec}
                                  fullWidth
                                  size="small"
                                  variant="standard"
                                  label=""
                                  defaultValue={String(item.vparcela.toFixed(2))}
                                  valor={handleParcelaValueChange}
                                  sx={{ '& input': { textAlign: 'right', fontWeight: 600, fontSize: 12, p: 0 } }}
                                />
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                    {!gerandoParcelas && listaParcelas.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mt: 0.75,
                          px: 1.25,
                          py: 0.6,
                          borderRadius: '8px',
                          bgcolor: alpha(colors.primarySolid, 0.08),
                        }}
                      >
                        <Typography variant="caption" color="text.secondary">
                          {listaParcelas.length} parcela{listaParcelas.length > 1 ? 's' : ''}
                        </Typography>
                        <Typography variant="body2" fontWeight={700} sx={{ color: colors.primarySolid }}>
                          {formatarMoeda(totalParcelas)}
                        </Typography>
                      </Box>
                    )}
                  </>
                )}
              </Box>

              {/* ── COL 3: TOTAIS (novo layout) ── */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  p: 2,
                  gap: 0,
                  bgcolor: bgSubtle,
                  [MQ_PHONE]: {
                    p: 1.5,
                  },
                }}
              >
                <Typography sx={sectionLabel}>Resumo</Typography>

                {/* subtotal */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', py: 0.75 }}>
                  <Typography variant="body2" color="text.secondary">Subtotal</Typography>
                  <Typography variant="body2" fontWeight={500}>{formatarMoeda(totalItens)}</Typography>
                </Box>

                <Divider sx={{ borderColor: borderColor }} />

                {/* desconto */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', py: 0.75 }}>
                  <Typography variant="body2" color="text.secondary">Desconto</Typography>
                  <Typography variant="body2" fontWeight={500} sx={{ color: DESCONTO_COLOR }}>
                    {valorDesconto > 0 ? `– ${formatarMoeda(valorDesconto)}` : formatarMoeda(0)}
                  </Typography>
                </Box>

                {/* acréscimo */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', py: 0.75 }}>
                  <Typography variant="body2" color="text.secondary">Acréscimo</Typography>
                  <Typography variant="body2" fontWeight={500} color="warning.main">
                    {valorAcrescimo > 0 ? `+ ${formatarMoeda(valorAcrescimo)}` : formatarMoeda(0)}
                  </Typography>
                </Box>

                {/* TOTAL FINAL — bloco destacado */}
                <Box
                  sx={{
                    mt: 1.5,
                    p: 2,
                    borderRadius: '10px',
                    bgcolor: isDark ? alpha(TOTAL_PAGAR_COLOR, 0.18) : alpha(TOTAL_PAGAR_COLOR, 0.07),
                    border: `0.5px solid ${isDark ? alpha(TOTAL_PAGAR_COLOR, 0.4) : alpha(TOTAL_PAGAR_COLOR, 0.22)}`,
                  }}
                >
                  <Typography variant="caption" sx={{ color: TOTAL_PAGAR_COLOR, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                    Total a pagar
                  </Typography>
                  <Typography
                    title={formatarMoeda(totalFinal)}
                    sx={{
                      fontSize: fontSizeTotalPagar(formatarMoeda(totalFinal)),
                      fontWeight: 600,
                      color: TOTAL_PAGAR_COLOR,
                      lineHeight: 1.1,
                      mt: 0.25,
                      fontVariantNumeric: 'tabular-nums',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {formatarMoeda(totalFinal)}
                  </Typography>
                  <Typography variant="caption" sx={{ color: TOTAL_PAGAR_COLOR, opacity: 0.75 }}>
                    {quantidadeItens} {quantidadeItens === 1 ? 'item' : 'itens'}
                    {formasPagamentoSelecionadas.length > 0 && ` · ${formasPagamentoSelecionadas.length} forma${formasPagamentoSelecionadas.length > 1 ? 's' : ''}`}
                  </Typography>
                </Box>

                {/* barra de progresso de pagamento */}
                {!isOrcamento && tpag !== 2 && (
                  <Box sx={{ mt: 1.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                      <Typography variant="caption" color="text.secondary">
                        Pago: {formatarMoeda(totalPago)}
                      </Typography>
                      <Typography variant="caption" color={totalPagoSuficiente ? 'success.main' : 'text.secondary'} fontWeight={totalPagoSuficiente ? 600 : 400}>
                        {Math.round(percentualPago)}%
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={percentualPago}
                      sx={{
                        height: 5,
                        borderRadius: 3,
                        bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                        '& .MuiLinearProgress-bar': {
                          borderRadius: 3,
                          bgcolor: totalPagoSuficiente ? 'success.main' : colors.primarySolid,
                        },
                      }}
                    />
                  </Box>
                )}

                {/* falta pagar / troco */}
                <Box sx={{ mt: 1.25, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                  {!isOrcamento && tpag !== 2 && faltaPagar > 0.01 && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 1.5,
                        py: 1,
                        borderRadius: '8px',
                        bgcolor: isDark ? 'rgba(237,108,2,0.12)' : 'rgba(237,108,2,0.08)',
                        border: `0.5px solid ${isDark ? 'rgba(237,108,2,0.3)' : 'rgba(237,108,2,0.2)'}`,
                      }}
                    >
                      <Typography variant="caption" fontWeight={600} color="warning.main">Falta pagar</Typography>
                      <Typography variant="subtitle2" fontWeight={700} color="warning.main">
                        {formatarMoeda(faltaPagar)}
                      </Typography>
                    </Box>
                  )}

                  {troco > 0.01 && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 1.5,
                        py: 1,
                        borderRadius: '8px',
                        bgcolor: isDark ? 'rgba(46,125,50,0.12)' : 'rgba(46,125,50,0.07)',
                        border: `0.5px solid ${isDark ? 'rgba(46,125,50,0.3)' : 'rgba(46,125,50,0.2)'}`,
                      }}
                    >
                      <Typography variant="caption" fontWeight={600} color="success.main">Troco</Typography>
                      <Typography variant="subtitle2" fontWeight={700} color="success.main">
                        {formatarMoeda(troco)}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>

            </Box>

            <input type="hidden" name="pagamento" value={tipoPagamentoFat} />
            <input type="hidden" name="qtdparcelas" value={qtdParcelas} />
            <input type="hidden" name="idparceiro" value={idParceiroSelecionado} />
          </Form>
          )}
        </DialogContent>

        {/* ── FOOTER ── */}
        <Box
          sx={{
            px: 2,
            py: 1.25,
            borderTop: `0.5px solid ${borderColor}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: theme.palette.background.paper,
            flexShrink: 0,
            [MQ_PHONE]: {
              px: 1.25,
              py: 1,
            },
          }}
        >
          {/* atalhos visíveis mas discretos — some no celular, sem teclado
              físico não fazem sentido (mesmo tratamento do cabeçalho). */}
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', [MQ_PHONE]: { display: 'none' } }}>
            <Typography variant="caption" color="text.disabled">
              <KbdChip label="Esc" /> {podeReabrirNfce ? 'nova venda' : 'cancelar'}
            </Typography>
            {!podeReabrirNfce && (
              <Typography variant="caption" color="text.disabled">
                <KbdChip label="F9" /> desconto
              </Typography>
            )}
          </Box>

          <Box sx={{ display: 'flex', gap: 1, width: 'auto', [MQ_PHONE]: { width: '100%', gap: 0.75 } }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={isLoading}
              size="small"
              sx={{
                borderColor: borderColor,
                color: 'text.secondary',
                [MQ_PHONE]: { flex: '0 0 auto', px: 1.5 },
              }}
            >
              {podeReabrirNfce ? 'Fechar' : 'Cancelar'}
            </Button>
            <Button
              variant="contained"
              onClick={podeReabrirNfce ? () => { setUltimoIdmovCriado(idVendaImpressao); setOpenDialogNfce(true); } : finalizarVenda}
              disabled={
                podeReabrirNfce ? false : (
                  isLoading ||
                  quantidadeItens === 0 ||
                  (!isOrcamento && tpag !== 2 && !totalPagoSuficiente && formasPagamentoSelecionadas.length === 0) ||
                  (!isOrcamento && tpag === 2 && !idParceiroSelecionado) ||
                  (!isOrcamento && tpag === 2 && idParceiroSelecionado === Environment.URL_IDPARCEIRO) ||
                  gerandoParcelas
                )
              }
              startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : podeReabrirNfce ? <ReceiptLongIcon /> : <CheckCircleIcon />}
              size="medium"
              sx={{
                background: colors.primaryGradient,
                color: colors.textOnPrimary,
                '&:hover': { background: colors.hoverGradient },
                '&.Mui-disabled': { background: alpha(colors.primarySolid, 0.3), color: alpha(colors.textOnPrimary, 0.6) },
                minWidth: 160,
                gap: 1,
                [MQ_PHONE]: { flex: '1 1 auto', minWidth: 0 },
              }}
            >
              {podeReabrirNfce ? 'Emitir NFC-e' : 'Finalizar venda'}
              <Box sx={{ [MQ_PHONE]: { display: 'none' } }}>
                <KbdChip label="F12" />
              </Box>
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* ── Dialogs secundários (inalterados) ── */}
      <DialogDescontoAcrescimo
        open={openDescontoDialog}
        onClose={() => setOpenDescontoDialog(false)}
        totalItens={totalItens}
        desconto={desconto}
        acrescimo={acrescimo}
        onDescontoChange={setDesconto}
        onAcrescimoChange={setAcrescimo}
        formatarMoeda={formatarMoeda}
        colors={colors}
      />

      <DialogNovoParceiro
        open={openNovoParceiroDialog}
        onClose={() => setOpenNovoParceiroDialog(false)}
        onCreated={handleParceiroCriado}
        colors={colors}
      />

      <DialogSelecionarParceiro
        open={openSelecionarParceiroDialog}
        onClose={() => setOpenSelecionarParceiroDialog(false)}
        onSelect={handleParceiroSelecionado}
        colors={colors}
      />

      <Dialog open={openNotaFiscalDialog} onClose={handleCancelarEmitirNota} maxWidth="xs" fullWidth TransitionComponent={Zoom}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ReceiptLongIcon sx={{ color: colors.primarySolid }} /> Emitir Nota Fiscal?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Venda realizada com sucesso! Deseja emitir a nota fiscal agora?</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={handleCancelarEmitirNota} variant="outlined">Não</Button>
          <Button
            onClick={handleConfirmarEmitirNota}
            variant="contained"
            startIcon={<ReceiptIcon />}
            sx={{ background: colors.primaryGradient, color: colors.textOnPrimary, '&:hover': { background: colors.hoverGradient } }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <DialogVisualizarVenda
        open={openPdfViewer}
        pdfUrl={pdfBlobUrl}
        idVenda={idVendaImpressao}
        onClose={handleCloseVisualizarVenda}
        onGerarImpressaoCaixa={handleImpressaoCaixa}
        onGerarImpressaoTermica={handleImpressaoTermica}
        onEmitirNota={() => { setUltimoIdmovCriado(idVendaImpressao); setOpenDialogNfce(true); }}
        notaEmitidaComSucesso={notaEmitidaComSucesso}
      />

      <Dialogsendnfce
        selectedId={ultimoIdmovCriado}
        open={openDialogNfce}
        onClose={handleCloseNfceDialog}
        incluirCpf={incluirCpf ?? false}
        colors={colors}
        formaPagamentoVenda={ultimaFormaPagamentoVenda}
        isOrcamento={ultimaVendaOrcamento}
        onMensagemSucesso={props.onMensagemSucesso}
      />

      <DialogAutorizacaoGerente
        open={openAutorizacaoEdicao}
        onClose={() => { setOpenAutorizacaoEdicao(false); setPendingEdicao(null); }}
        colors={colors}
        corDestaque={colors.primarySolid}
        titulo={`Salvar edição da venda #${numeroVendaEmEdicao || ''}`}
        mensagem="Essa venda vai ser atualizada (mesma venda, não cria outra). Informe usuário e senha de quem autoriza."
        onConfirmar={async (login, senha) => {
          if (!pendingEdicao) return new Error('Nada pra salvar.');
          return SessaoCaixaService.editarVendaPdv(idProp, login, senha, pendingEdicao);
        }}
        onAutorizado={handleEdicaoAutorizada}
      />

      {/* Flutuante, na frente do diálogo de finalizar venda (zIndex bem
          alto, Snackbar é portal separado do Dialog) — não mexe no layout
          da tela, só sobrepõe. Erro não some sozinho (nem por tempo, nem
          clicando fora sem querer) — só no X (ver handleCloseMsg). Sucesso
          não aparece aqui quando o PDV recebe ele no header (sucessoNoHeader). */}
      <Snackbar
        open={openmsg && !sucessoNoHeader}
        autoHideDuration={tms === 'error' ? null : 6000}
        onClose={handleCloseMsg}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        style={{ zIndex: 999999 }}
        sx={{ zIndex: 999999 }}
      >
        <Alert onClose={handleCloseMsg} severity={tms} variant="filled" sx={{ borderRadius: 2 }}>{msg}</Alert>
      </Snackbar>
    </>
  );
};
